module.exports = __webpack_public_path__ + "static/media/Baloo-Regular.9525712c.ttf";